export const alert = {
    namespaced: true,
    state: {
        alerts: new Map(),
    },
    getters: {
        alerts(state) {
            return new Map(Array.from(state.alerts).reverse())
        }
    },
    actions: {
        show({ commit, state }, payload) {

            if (state.alerts.size >= 3) {
                const [oldKey, alert] = state.alerts.entries().next().value;
                clearTimeout(alert.timeoutID)
                commit('removeAlert', oldKey)
            }

            const key = window.performance.now().toString()
            payload.key = key

            payload.timeoutID = setTimeout(() => {
                commit('removeAlert', key)
            }, 6000)

            commit('addAlert', payload)

        }
    },
    mutations: {
        addAlert(state, payload) {
            state.alerts.set(payload.key, {
                dismissible: payload.dismissible,
                color: payload.color,
                message: payload.message,
                timeoutID: payload.timeoutID,
            })
        },
        removeAlert(state, key) {
            state.alerts.delete(key)
        }
    }
};